import React from 'react';

import { ButtonBase, SvgIcon } from '@material-ui/core';

import styles from './IconButton.module.scss';

interface IProps {
	color?: 'regular' | 'blue' | 'transparent';
	size?: 'medium' | 'large';
	/** the ionic icon to display */
	icon: React.ElementType;
	disabled?: boolean;
	type?: 'submit';
	onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const IconButton: React.FC<IProps> = (props) => {
	const buttonClasses = [styles['icon-button__button']];
	if (props.color) {
		buttonClasses.push(styles[`icon-button__button--${props.color}`]);
	}
	if (props.size) {
		buttonClasses.push(styles[`icon-button__button--${props.size}`]);
	}

	const iconClasses = [styles['icon-button__icon']];
	if (props.size) {
		iconClasses.push(styles[`icon-button__icon--${props.size}`]);
	}

	return (
		<div className={styles['icon-button']}>
			<ButtonBase
				focusRipple
				className={buttonClasses.join(' ')}
				onClick={props.onClick}
				disabled={props.disabled}
				type={props.type}
			>
				<SvgIcon
					component={props.icon}
					classes={{ root: iconClasses.join(' ') }}
				/>
			</ButtonBase>
		</div>
	);
};
